import './App.css';

import SignIn from './components/signinComponent/signin';

import { Route, Routes } from "react-router-dom";


function App() {
  
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<SignIn />} />
      </Routes>
    </div>
  );
}

export default App;
